// Statistiques : série de jours, avancement, rythme, projection par partiel (calculs seulement, pas de HTML).
window.computeStreak = function() {
    var tasks = window.state.tasks;
    if (!tasks.length) return 0;
    var byDate = {};
    tasks.forEach(function(t) { (byDate[t.date] = byDate[t.date] || []).push(t); });
    var streak = 0;
    var d = window.todayLogical();
    for (var i = 0; i < 3650; i++) {
        var ds = window.toYYYYMMDD(d);
        var dayTasks = byDate[ds];
        if (dayTasks && dayTasks.length) {
            var allDone = dayTasks.every(function(t) { return t.status === 'done'; });
            if (!allDone) {
                if (i === 0) { d.setDate(d.getDate() - 1); continue; }
                break;
            }
            streak++;
        }
        d.setDate(d.getDate() - 1);
    }
    return streak;
};

// --- STATISTIQUES -------------------------------------------------------------------------------------------
// Tout se calcule à partir de ce que le site a déjà : les tâches (faites ou non), le journal d'apprentissage
// (QCM, flashcards, active recall, et les séances chronométrées) et les partiels. Aucune donnée nouvelle.
// « 2026-09-14 » → « dim. 14 septembre ». Utilisé par les projections et les infobulles des courbes.
window.statsJours = function(n) {
    var out = [], d = window.todayLogical();
    for (var i = n - 1; i >= 0; i--) { var x = new Date(d); x.setDate(x.getDate() - i); out.push(window.toYYYYMMDD(x)); }
    return out;
};
// Un item est « vu » selon la même règle que la barre des partiels : TOUS ses J0 cochés — chaque sous-partie, et
// le renforcement pédiatrie quand il en a un. On rend aussi la DATE à laquelle il l'a été.
window.statsItems = function() {
    var par = {};
    window.state.tasks.forEach(function(t) {
        var base = String(t.baseItemId || t.itemId || '');
        if (!base) return;
        var e = par[base] || (par[base] = { seq: {}, dates: {}, matiere: t.matiere, taches: 0, faites: 0 });
        e.taches++; if (t.status === 'done') e.faites++;
        if (t.type !== 'J0') return;
        var q = t.isDouble ? 'pediatrie' : String(t.itemId);
        if (!(q in e.seq)) e.seq[q] = true;
        if (t.status !== 'done') e.seq[q] = false;
        else if (!e.dates[q] || t.date < e.dates[q]) e.dates[q] = t.date;
    });
    Object.keys(par).forEach(function(id) {
        var e = par[id];
        var qs = Object.keys(e.seq);
        e.vu = qs.every(function(q) { return e.seq[q]; });
        // vu le jour de la DERNIÈRE sous-partie découverte : c'est là qu'il devient complet
        e.vuLe = e.vu ? qs.map(function(q) { return e.dates[q]; }).filter(Boolean).sort().pop() || null : null;
    });
    return par;
};
// Matières d'un item : la principale de la tâche, plus les collèges secondaires du catalogue.
window.statsMatieres = function(itemId, matiere) {
    var def = window.itemById(String(itemId));
    return [matiere].concat(def ? def.collegesSecondaires : []).filter(Boolean);
};
window.statsTemps = function() {
    var log = ((window.state.learning || {}).log) || [];
    var out = { total: 0, n: 0, parCat: { j0: 0, rev: 0, brass: 0 }, parMatiere: {}, parJour: {} };
    log.forEach(function(e) {
        if (e.m !== 'time' || !e.min) return;
        out.total += e.min; out.n++;
        var cat = e.cat || 'rev';
        if (out.parCat[cat] == null) out.parCat[cat] = 0;
        out.parCat[cat] += e.min;
        var def = window.itemById(String(e.i || ''));
        var mat = def ? def.matiere : 'Autre';
        out.parMatiere[mat] = (out.parMatiere[mat] || 0) + e.min;
        var j = window.toYYYYMMDD(new Date(e.t || Date.now()));
        out.parJour[j] = (out.parJour[j] || 0) + e.min;
    });
    return out;
};
window.statsQcm = function() {
    var log = ((window.state.learning || {}).log) || [];
    var n = 0, somme = 0, nRecall = 0, sommeRecall = 0, nFlash = 0;
    log.forEach(function(e) {
        if (e.m === 'qcm') { n++; somme += (typeof e.s === 'number' ? e.s : 0); }
        else if (e.m === 'recall') { nRecall++; sommeRecall += (typeof e.s === 'number' ? e.s : 0); }
        else if (e.m === 'flash') nFlash++;
    });
    return { qcm: n, qcmPct: n ? Math.round(somme / n * 100) : null, recall: nRecall,
        recallPct: nRecall ? Math.round(sommeRecall / nRecall * 100) : null, flash: nFlash };
};
// Rythme : combien d'items ont été VUS par jour, et combien de séances cochées, sur les n derniers jours.
window.statsRythme = function(n) {
    var jours = window.statsJours(n), parItem = window.statsItems();
    var vus = {}, seances = {}, j0 = {};
    jours.forEach(function(j) { vus[j] = 0; seances[j] = 0; j0[j] = 0; });
    Object.keys(parItem).forEach(function(id) { var d = parItem[id].vuLe; if (d && d in vus) vus[d]++; });
    // j0 : sous-parties découvertes ce jour-là (un J0 coché = une sous-partie, un item non découpé, ou un renforcement)
    window.state.tasks.forEach(function(t) { if (t.status === 'done' && t.date in seances) { seances[t.date]++; if (t.type === 'J0') j0[t.date]++; } });
    return jours.map(function(j) { return { jour: j, vus: vus[j], seances: seances[j], j0: j0[j] }; });
};
// Projection : à ce rythme, quand aurai-je vu tous les items d'un partiel ?
// Le rythme est mesuré sur les 21 derniers jours — assez long pour lisser un week-end, assez court pour
// refléter la période en cours. Un item déjà vu ne compte plus, un item non planifié n'existe pas.
// Premier jour où une séance a été cochée : la fenêtre de mesure du rythme ne remonte pas avant. Quelqu'un qui a
// commencé il y a cinq jours a un rythme sur cinq jours, pas sur vingt-et-un dont seize à zéro.
window.statsDebut = function() {
    var debut = null;
    window.state.tasks.forEach(function(t) { if (t.status === 'done' && t.date && (!debut || t.date < debut)) debut = t.date; });
    return debut;
};
window.statsFenetre = function(max) {
    var debut = window.statsDebut(); if (!debut) return max;
    var depuis = -window.daysUntil(debut) + 1; // aujourd'hui compris
    return Math.max(1, Math.min(max, depuis));
};
// marge : « tout avoir vu X jours avant le partiel » (réglable sous chaque partiel, 30 par défaut) — la date cible
// est le partiel moins la marge, et c'est elle que le planning et le rythme doivent tenir.
// L'unité est la SOUS-PARTIE, pas l'item : chaque J0 du planning en est une (un item non découpé, une sous-partie
// d'un item découpé, ou un renforcement pédiatrie), vue quand il est coché. C'est ce qu'on fait chaque jour ; un
// item entier, lui, ne devient « vu » qu'une fois tous ses J0 cochés, ce qui rendait le rythme illisible.
window.statsProjection = function(specs, dateExamen, marge) {
    var total = 0, vus = 0;
    window.state.tasks.forEach(function(t) {
        if (t.type !== 'J0') return;
        var mats = window.statsMatieres(String(t.baseItemId || t.itemId || ''), t.matiere);
        if (!specs.some(function(sp) { return mats.indexOf(sp) !== -1; })) return;
        total++; if (t.status === 'done') vus++;
    });
    var reste = total - vus;
    var fenetre = window.statsFenetre(21);
    var rythme = window.statsRythme(fenetre).reduce(function(a, x) { return a + x.j0; }, 0) / fenetre;
    var jours = reste > 0 ? (rythme > 0 ? Math.ceil(reste / rythme) : null) : 0;
    var fin = null;
    if (jours !== null) { var d = window.todayLogical(); d.setDate(d.getDate() + jours); fin = window.toYYYYMMDD(d); }
    var restants = dateExamen ? window.daysUntil(dateExamen) : null;
    // Ce qu'il FAUDRAIT tenir pour y être : le rythme cible, à comparer au rythme réel.
    var cible = (restants && restants > 0 && reste > 0) ? (reste / restants) : (reste > 0 ? null : 0);
    // Le planning lui-même : la date du dernier J0 encore à faire dans ces matières. S'il tombe après le partiel,
    // suivre le planning ne suffira pas, quel que soit le rythme — c'est le premier verdict à donner.
    var dernierJ0 = null;
    window.statsJ0Lointains(specs).forEach(function(x) { if (x.task && (!dernierJ0 || x.task.date > dernierJ0)) dernierJ0 = x.task.date; });
    // Date cible : le partiel moins la marge. Le rythme « objectif » vise cette date-là.
    marge = Math.max(0, parseInt(marge, 10) || 0);
    var dateCible = null, restantsCible = null, cibleMarge = null;
    if (dateExamen) {
        var dc = window.parseDateLocal(dateExamen); dc.setDate(dc.getDate() - marge); dateCible = window.toYYYYMMDD(dc);
        restantsCible = window.daysUntil(dateCible);
        cibleMarge = (restantsCible > 0 && reste > 0) ? (reste / restantsCible) : (reste > 0 ? null : 0);
    }
    return { total: total, vus: vus, reste: reste, pct: total ? Math.round(vus / total * 100) : 0,
        rythme: rythme, fenetre: fenetre, jours: jours, fin: fin, restants: restants, cible: cible,
        marge: marge, dateCible: dateCible, restantsCible: restantsCible, cibleMarge: cibleMarge,
        dernierJ0: dernierJ0, planTient: (dernierJ0 && dateExamen) ? (dernierJ0 <= dateExamen) : null,
        planTientCible: (dernierJ0 && dateCible) ? (dernierJ0 <= dateCible) : null,
        aTemps: (fin && dateExamen) ? (fin <= dateExamen) : (reste === 0 ? true : null),
        aTempsCible: (fin && dateCible) ? (fin <= dateCible) : (reste === 0 ? true : null) };
};
// Pour chaque matière d'un partiel : l'item (sous-partie ou renforcement pédiatrie) dont le J0 encore à faire est le
// plus éloigné — c'est lui qui fixe la date à laquelle la matière sera entièrement découverte.
window.statsJ0Lointains = function(specs) {
    return (specs || []).map(function(sp) {
        var loin = null;
        window.state.tasks.forEach(function(t) {
            if (t.type !== 'J0' || t.status !== 'pending' || !t.date) return;
            if (window.statsMatieres(String(t.baseItemId || t.itemId || ''), t.matiere).indexOf(sp) === -1) return;
            if (!loin || t.date > loin.date) loin = t;
        });
        return { spec: sp, task: loin };
    });
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const computeStreak = window.computeStreak;
export const statsJours = window.statsJours;
export const statsItems = window.statsItems;
export const statsMatieres = window.statsMatieres;
export const statsTemps = window.statsTemps;
export const statsQcm = window.statsQcm;
export const statsRythme = window.statsRythme;
export const statsDebut = window.statsDebut;
export const statsFenetre = window.statsFenetre;
export const statsProjection = window.statsProjection;
export const statsJ0Lointains = window.statsJ0Lointains;
